(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams-create.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams-create.js');
'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  Grid,
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  TeamsCreateName,
  TeamsCreateInvite
} = svs.arena.pages.teams.components;
const {
  showConfirmEmailDialog,
  showTechnicalError
} = svs.arena.pages.teams.dialogs;
const {
  checkAndShowSyndicateTermsDialogAsync
} = svs.syndicate.rules_and_terms;
const {
  teamsService
} = svs.arena.service;
const {
  TEAMS
} = svs.arena.constants.routes;
const {
  contactInfoStatus
} = svs.arena.constants;

const TeamsCreate = () => {
  const [createdTeamId, setCreatedTeamId] = React.useState(0);
  const history = useHistory();
  const [isForbidden, setIsForbidden] = React.useState(true);
  const teams = ReactRedux.useSelector(state => state.teams.teams);
  const hasTeams = teams.length > 0;
  React.useEffect(() => {
    const redirectDependingOnStatus = () => {
      if (hasTeams) {
        history.push(TEAMS);
      } else {
        svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
      }
    };
    const checkEligibility = async () => {
      var _svs;
      const {
        data: emailData
      } = await teamsService.getPlayerEmailAsync();
      if (svs.core.userSession.isBlocked()) {
        svs.accountservices.national_suspension_message.showNationalSuspensionCreateSyndicateMessageNew(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
        });
      } else if ((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.day_time_limit) !== null && _svs !== void 0 && (_svs = _svs.data) !== null && _svs !== void 0 && (_svs = _svs.dayTimeLimit) !== null && _svs !== void 0 && _svs.dayTimeExpired) {
        var _svs2;
        (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.day_time_limit) === null || _svs2 === void 0 || (_svs2 = _svs2.notices) === null || _svs2 === void 0 || _svs2.createSyndicate(() => {
          redirectDependingOnStatus();
        });
      } else if (!emailData) {
        showTechnicalError(() => {
          redirectDependingOnStatus();
        });
      } else if ((emailData === null || emailData === void 0 ? void 0 : emailData.emailStatus) === contactInfoStatus.NOTOFFEREDVERIFICATION || (emailData === null || emailData === void 0 ? void 0 : emailData.emailStatus) === contactInfoStatus.VERIFIED) {
        setIsForbidden(false);
      } else if (await showConfirmEmailDialog()) {
        svs.utils.url.navigate(svs.core.urlMapping.get('myProfileVerifyEmail'));
      } else {
        redirectDependingOnStatus();
      }
      await checkAndShowSyndicateTermsDialogAsync();
    };
    checkEligibility();
  }, [history, hasTeams]);
  if (isForbidden) {
    return null;
  }
  return React.createElement("div", {
    className: "margin-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "main-content-constrained",
    xs: 12,
    sm: {
      col: 10
    },
    am: {
      col: 8
    },
    md: {
      col: 6
    },
    lg: {
      col: 5
    }
  }, createdTeamId === 0 && React.createElement(TeamsCreateName, {
    setCreatedTeamId: setCreatedTeamId
  }), createdTeamId > 0 && React.createElement(TeamsCreateInvite, {
    createdTeamId: createdTeamId
  })))));
};
svs.arena.pages.teams.TeamsCreate = TeamsCreate;

 })(window);